import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSnow({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4746 10.241C22.4227 10.241 22.3727 10.2489 22.3221 10.2489C21.744 7.81373 19.5633 6 16.9506 6C14.207 6 11.9375 8.00181 11.5061 10.6238C11.1635 10.5271 10.8051 10.4738 10.4309 10.4738C8.53103 10.4738 6.94551 11.8016 6.5391 13.5778C5.05352 14.1591 4 15.602 4 17.2934C4 19.5017 5.78808 21.2898 7.99573 21.2898H22.4746C25.5267 21.2898 28 18.8184 28 15.767C28 12.7157 25.526 10.241 22.4746 10.241Z"
        fill="white"
      />
      <path
        d="M9.50028 25.5099C10.1464 25.3574 10.5466 24.7099 10.3941 24.0638C10.2416 23.4176 9.59416 23.0174 8.94799 23.1699C8.30182 23.3224 7.90165 23.9699 8.05416 24.616C8.20667 25.2622 8.85411 25.6624 9.50028 25.5099Z"
        fill="white"
      />
      <path
        d="M15.7879 25.1802C16.2574 24.7108 16.2574 23.9496 15.7879 23.4802C15.3185 23.0107 14.5573 23.0107 14.0878 23.4802C13.6184 23.9496 13.6184 24.7108 14.0878 25.1802C14.5573 25.6497 15.3184 25.6497 15.7879 25.1802Z"
        fill="white"
      />
      <path
        d="M21.502 25.1808C21.9715 24.7114 21.9715 23.9502 21.502 23.4808C21.0326 23.0113 20.2714 23.0113 19.8019 23.4808C19.3325 23.9502 19.3325 24.7114 19.8019 25.1808C20.2714 25.6503 21.0326 25.6503 21.502 25.1808Z"
        fill="white"
      />
    </svg>
  );
}
